module.exports = __webpack_public_path__ + "static/media/galerija_2017 (29).0e125fe4.jpg";